// Only publishable keys
// TODO: use process.env once the website can reference env vars at runtime
export default {
  gtmId: 'GTM-TF92NVT',
  BUGSNAG_KEY_WEBSITE: '3b568f4d381489f2e838beae619ad1c5',
};
